module.exports = "data:image/gif;base64,R0lGODlhCgAKAIAAABcoOY2UmSH5BAAAAAAALAAAAAAKAAoAAAIUhI8Qy2vdHnQqKskeRmGfXk3JWAAAOw=="